"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A ramp utility that calls a given function repeatedly until interrupted.
 * Used in semantic player so far (could be used to smoothen dymo parameters)
 * @constructor
 */
class Ramp {
    constructor() {
        this.currentValue = 0;
    }
    setValue(value) {
        this.currentValue = value;
    }
    startOrUpdate(targetValue, duration, frequency, callback) {
        if (duration > frequency) {
            clearInterval(this.intervalID);
            this.delta = (targetValue - this.currentValue) / (duration / frequency);
            this.intervalID = setInterval(() => {
                var nextValue = this.currentValue + this.delta;
                if (Math.abs(targetValue - nextValue) < Math.abs(targetValue - this.currentValue)) {
                    this.currentValue = nextValue;
                    callback(this.currentValue);
                }
                else {
                    //can't get closer..
                    clearInterval(this.intervalID);
                }
            }, frequency);
        } /* else {
            this.currentValue = targetValue;
            callback(this.currentValue);
        }*/
    }
}
exports.Ramp = Ramp;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/util/ramp.js
// module id = 1312
// module chunks = 3